import React from 'react';

interface FormTextareaProps {
  name: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  description?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  rows?: number;
  icon?: React.ReactNode;
  className?: string;
}

const FormTextarea: React.FC<FormTextareaProps> = ({
  name,
  label,
  placeholder,
  required,
  description,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  rows = 4,
  icon,
  className = ""
}) => (
  <div className={`flex flex-col ${className}`}>
    <label className="mb-1.5 text-sm font-black text-gray-900 tracking-tight">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <div className="relative">
      {icon && <div className="absolute left-4 top-4 text-gray-400">{icon}</div>}
      <textarea
        className={`w-full rounded-xl border border-slate-200 px-4 py-3 text-sm font-medium focus:border-blue-500 focus:outline-none focus:ring-4 focus:ring-blue-500/10 transition-all resize-none ${icon ? 'pl-11' : ''
          } ${error ? 'border-red-500' : 'border-slate-200'} ${disabled ? 'bg-gray-50 text-gray-400' : 'bg-white text-gray-800'}`}
        placeholder={placeholder}
        rows={rows}
        value={value || ''}
        onChange={(e) => onChange?.(e.target.value)}
        onBlur={onBlur}
        disabled={disabled}
      />
    </div>
    {description && <p className="mt-1.5 text-xs text-gray-400 font-medium leading-relaxed">{description}</p>}
    {error && <p className="mt-1.5 text-xs text-red-500 font-bold">{error}</p>}
  </div>
);

export default FormTextarea;
